@use '../../scss/utility';

:host {
  display: flex;
  flex-direction: column;

  margin-block: var(--wb-spacing-l);

  @include utility.breakpoint-from(mq3) {
    margin-block-end: 0;
  }

  @include utility.breakpoint-from(mq5) {
    padding-block-start: var(--wb-spacing-m);
    margin-block-start: var(--wb-spacing-m);
    border-block-start: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-85);
  }
}
